/*
 * Product · Tested: the "View Full VOC Report" button opens the report pop-up
 * (a native <dialog>). Closes with the X button, Esc, or a click on the dimmed
 * backdrop, like the Replo modal. Re-initialises on shopify:section:load.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.pdpTestedInit === 'true') return;
    root.dataset.pdpTestedInit = 'true';

    var dialog = root.querySelector('[data-pdp-tested-dialog]');
    var opener = root.querySelector('[data-pdp-tested-open]');
    if (!dialog || !opener) return;

    function open() {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        onClosed();
      }
    }

    function onClosed() {
      document.documentElement.style.overflow = '';
      opener.focus({ preventScroll: true });
    }

    opener.addEventListener('click', open);
    dialog.addEventListener('close', onClosed);

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-pdp-tested-close]')) {
        close();
        return;
      }
      // A click outside the white box lands on the <dialog> itself (the backdrop).
      if (event.target === dialog) close();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp-tested]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
